import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const ButtonContainer = (props) => (
  <Box display="flex" alignItems="center">
    {props.children}
  </Box>
);

ButtonContainer.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ButtonContainer;
